import { RootState } from "common/reducers";
import { authorizedToken, token } from "common/selectors/token.selectors";
import { currentOrgId } from "common/selectors/org.selectors";
import { List } from "immutable";
import { currentUserOrgId } from "src/common/selectors/user.selectors";

/**
 * Checks if occ_pay is an active payment provider
 *
 * @param {RootState} state The RootState
 * @param {{ kind: string }} options
 * @returns {boolean} boolean
 */
export const occPayProviderActive = (state: RootState) => {
  return (
    authorizedToken(state, { orgId: currentOrgId(state) ?? currentUserOrgId(state), kind: "occ_pay" })?.authorized ||
    false
  );
};

export const occPayPaymentOption = (state: RootState) => {
  return (token(state, { kind: "occ_pay" })?.getIn(["data", "payment_options"]) as List<string>) || List<string>([]);
};
